import axios from 'axios';
import { SET_APPLICATION } from '../constants';


const setApplication = application => ({
    type: SET_APPLICATION,
    application,
}) 

export const fetchApplication = (app) => dispatch =>{
    let uri;
    if(app === 'cp'){
        uri = `/api/v2/leadgen/?app_type=${app}&${window.location.search.slice(1)}&destination=CP&requested_value=500000`;
    }else{
        uri = `/api/v2/leadgen/?app_type=${app}&${window.location.search.slice(1)}`;
    }
    return(
        axios.get(uri)
            .then(res => res.data)
            .then(application => dispatch(setApplication(application)))
            .catch(() => setApplication({
                application: {},
            }))
    )  
}
